import { render } from "./SegmentTab.vue?vue&type=template&id=63fa7a47&scoped=true"
import script from "./SegmentTab.vue?vue&type=script&lang=js"
export * from "./SegmentTab.vue?vue&type=script&lang=js"

import "./SegmentTab.vue?vue&type=style&index=0&id=63fa7a47&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fa7a47"]])

export default __exports__